<button mat-raised-button (click)="handleWhichFunctionToUse()" class="no-print" *ngIf="(_device.isWebview$ | async) === false">
	<img style="height: 30px" src="../../../assets/images/export-excel-48.png" />
	<ng-container *ngIf="!hideText">הורד דוח</ng-container>
</button>
